/**
 * 处理异常
 * @param {*} error
 */
import axios from 'axios'
import { pzLoginStorage } from '@/utils'
import { Message } from 'element-ui'
export function httpErrorStatusHandle(error) {
	// 处理被取消的请求
	if (axios.isCancel(error)) return console.error('请求的重复请求：' + error.message)
	let message = ''
	if (error && error.response) {
		switch (error.response.status) {
			case 400:
				message = '不小心开小差了(400)'
				break
			case 401:
				setTimeout(() => {
					const that = window.$nuxt
					const pzdsCookie = that.$cookies.get('pzdsCookie')
					if (!pzdsCookie && process.client) {
						that.$store.dispatch('user/UserResetToken')
						that.$router.push({ path: '/login' })
						Message.error('登录失效，请重新登录')
						return
					}
					logout()
				}, 0)
				break
			case 403:
				message = '该页面拒绝或禁止访问了'
				break
			case 404:
				message = '不小心开小差了(404)'
				break
			case 405:
				message = '请求方法有误，请联系客服处理'
				break
			case 406:
				message = '您操作的速度太快...请稍等再试'
				break
			case 429:
				message = '您操作的速度太快...请稍等再试'
				break
			case 460:
				message = '非法请求，请联系客服处理'
				break
			case 500:
				message = `500|服务器异常 ${error.response.data.requestId}`
				break
			case 502:
				message = '502|服务器无响应'
				break
			case 503:
				message = '503|服务器异常，请联系客服处理'
				break
			case 504:
				message = '504|网关超时'
				break
			case 529:
				message = '529|服务异常降级...请稍等再试'
				break
			case 612:
				message = '612|登录存在问题，请切换网络或稍后重试'
				break
			default:
				message = `${error.response.status}|异常问题，请联系客服处理`
				break
		}
	}
	if (error.message.includes('timeout')) message = '网络请求超时！'
	if (error.message.includes('Network')) message = window.navigator.onLine ? '服务端异常！' : '您断网了！'

	Message.error(message)
}
function logout() {
	const that = window.$nuxt
	// localStorage.setItem('userLoggedIn', 'false')
	const Events = that.$RongIMLib.Events
	that.$RongIMLib.removeEventListeners(Events.PULL_OFFLINE_MESSAGE_FINISHED)
	that.$RongIMLib.removeEventListeners(Events.CONVERSATION)
	that.$RongIMLib.removeEventListeners(Events.MESSAGES)
	that.$RongIMLib.removeEventListeners(Events.MESSAGE_RECEIPT_REQUEST)
	that.$RongIMLib.removeEventListeners(Events.READ_RECEIPT_RECEIVED)
	that.$RongIMLib.removeEventListeners(Events.MESSAGE_RECEIPT_RESPONSE)
	// 断开融云
	that.$RongIMLib.disconnect()
	// 重置IM
	that.$store.commit('ry/SET_CONVERSATION_LIST', [])
	that.$store.commit('ry/SET_TOKEN', null)
	that.$store.commit('ry/SET_USER_ID', null)
	that.$store.commit('ry/SET_CUSTOMER_INFO', {})
	that.$store.commit('ry/SET_HISTORY', [])
	that.$store.commit('ry/SET_MENTIONEDGROUPS_LIST', {})
	that.$store.commit('ry/SET_GLOBAL_SHOW_CHAT', false)
	that.$store.commit('ry/SET_PREVIEW_LIST', [])
	that.$store.commit('ry/SET_ALL_UNREAD_COUNT', 0)
	that.$store.commit('ry/SET_INPUTID_LIST', [])
	that.$store.commit('ry/SET_RY_SEND_READ', [])
	that.$store.commit('ry/SET_IM_SINGLECHAT', [])
	that.$cookies.set('countDown', 0)
	that.$store.dispatch('user/UserResetToken')
	that.$store.dispatch('user/UserLogout').then(res => {
		if (!res.success) {
			Message.error('退出失败')
			return
		}
		that.$router.push({ path: '/' })
		Message.success('退出成功')
		pzLoginStorage().onLoggedOut()
		that.$router.go(0)
	})
}
